<template>
	<div class="medicine-list-container">
		<!-- 列表页 -->
		<template v-if="showFlag">
			<!-- 页面头部 -->
			<div class="page-header">
				<div class="header-content">
					<div class="header-icon">
						<svg class="icon" viewBox="0 0 24 24">
							<path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"/>
						</svg>
					</div>
					<div class="header-text">
						<h1 class="page-title">热销药品管理</h1>
						<p class="page-description">药品信息的录入、管理与库存维护</p>
					</div>
					<div class="header-actions">
						<el-button 
							v-if="isAuth('rexiaonongchanpin','新增')" 
							type="primary" 
							icon="el-icon-plus" 
							@click="addOrUpdateHandler()" 
							class="add-btn"
						>
							新增药品
						</el-button>
					</div>
				</div>
			</div>

			<!-- 搜索和筛选区域 -->
			<div class="filter-section">
				<el-card class="filter-card" shadow="never">
					<div class="filter-content">
						<el-form :inline="true" :model="searchForm" class="search-form">
							<div class="filter-row">
								<div class="filter-group">
									<label class="filter-label">药品名称</label>
									<div class="filter-input">
										<el-input 
											v-model="searchForm.nongchanpinmingcheng" 
											placeholder="请输入药品名称" 
											clearable
											prefix-icon="el-icon-search"
											class="search-input"
										></el-input>
									</div>
								</div>



								<div class="filter-group">
									<label class="filter-label">品牌</label>
									<div class="filter-input">
										<el-input 
											v-model="searchForm.pinpai" 
											placeholder="请输入品牌名称" 
											clearable
											class="search-input"
										></el-input>
									</div>
								</div>


								
								<div class="filter-actions">
									<el-button 
										type="primary" 
										icon="el-icon-search" 
										@click="search()"
										class="search-btn"
									>
										查询
									</el-button>
									<el-button 
										icon="el-icon-refresh" 
										@click="resetSearch()"
										class="reset-btn"
									>
										重置
									</el-button>
								</div>
							</div>
						</el-form>
					</div>
				</el-card>
			</div>

			<!-- 操作栏 -->
			<div class="toolbar-section" v-if="dataListSelections.length > 0">
				<el-card class="toolbar-card" shadow="never">
					<div class="toolbar-content">
						<div class="selection-info">
							<i class="el-icon-info"></i>
							<span>已选择 <strong>{{ dataListSelections.length }}</strong> 项</span>
						</div>
						<div class="batch-actions">
							<el-button 
								v-if="isAuth('rexiaonongchanpin','删除')" 
								type="danger" 
								icon="el-icon-delete" 
								@click="deleteHandler()"
								:disabled="dataListSelections.length <= 0"
								class="batch-delete-btn"
							>
								批量删除
							</el-button>
						</div>
					</div>
				</el-card>
			</div>

			<!-- 数据表格 -->
			<div class="table-section">
				<el-card class="table-card" shadow="never">
					<el-table 
						class="data-table"
						:data="dataList"
						v-loading="dataListLoading"
						@selection-change="selectionChangeHandler"
						empty-text="暂无数据"
						element-loading-text="加载中..."
						element-loading-spinner="el-icon-loading"
					>
						<el-table-column 
							type="selection" 
							width="55" 
							align="center"
						></el-table-column>
						
						<el-table-column 
							label="序号" 
							type="index" 
							width="70" 
							align="center"
							:index="getTableIndex"
						></el-table-column>
						

						
						<el-table-column 
							prop="nongchanpinmingcheng"
							label="药品名称"
							min-width="150"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="medicine-name">
									<div class="medicine-icon">
										<svg viewBox="0 0 24 24">
											<path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"/>
										</svg>
									</div>
									<span class="medicine-text">{{ scope.row.nongchanpinmingcheng }}</span>
								</div>
							</template>
						</el-table-column>

						<el-table-column 
							prop="nongchanpintupian" 
							label="药品图片" 
							width="120" 
							align="center"
						>
							<template slot-scope="scope">
								<div class="medicine-image">
									<div class="image-wrapper" v-if="scope.row.nongchanpintupian">
										<img 
											v-if="scope.row.nongchanpintupian.substring(0,4)=='http'" 
											:src="scope.row.nongchanpintupian.split(',')[0]" 
											class="medicine-img"
											@error="handleImageError"
										>
										<img 
											v-else 
											:src="$base.url+scope.row.nongchanpintupian.split(',')[0]" 
											class="medicine-img"
											@error="handleImageError"
										>
									</div>
									<div class="image-placeholder" v-else>
										<i class="el-icon-picture"></i>
										<span>无图片</span>
									</div>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="chanpinfenlei"
							label="产品分类"
							width="120"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<el-tag type="info" size="small" class="category-tag">
									{{ scope.row.chanpinfenlei }}
								</el-tag>
							</template>
						</el-table-column>
						

						
						<el-table-column 
							prop="pinpai"
							label="品牌"
							width="120"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="brand-info">
									<span class="brand-text">{{ scope.row.pinpai }}</span>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="guigebaozhuang"
							label="规格包装"
							width="120"
							show-overflow-tooltip
						></el-table-column>
						

						

						
						<el-table-column 
							prop="alllimittimes"
							label="库存"
							width="80"
							align="center"
						>
							<template slot-scope="scope">
								<div class="stock-info">
									<el-tag 
										:type="getStockTagType(scope.row.alllimittimes)" 
										size="small"
										class="stock-tag"
									>
										{{ scope.row.alllimittimes == -1 ? '无限制' : scope.row.alllimittimes }}
									</el-tag>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="clicknum"
							label="点击次数"
							width="100"
							align="center"
						>
							<template slot-scope="scope">
								<div class="click-info">
									<i class="el-icon-view"></i>
									<span>{{ scope.row.clicknum || 0 }}</span>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="price"
							label="价格"
							width="100"
							align="center"
						>
							<template slot-scope="scope">
								<div class="price-info">
									<span class="price-symbol">¥</span>
									<span class="price-value">{{ scope.row.price }}</span>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							label="操作" 
							width="260" 
							align="center"
							fixed="right"
						>
							<template slot-scope="scope">
								<div class="action-buttons">
									<el-button 
										v-if="isAuth('rexiaonongchanpin','查看')" 
										type="info" 
										size="mini" 
										icon="el-icon-view"
										@click="addOrUpdateHandler(scope.row.id, 'info')"
										class="action-btn view-btn"
									>
										详情
									</el-button>
									<el-button 
										v-if="isAuth('rexiaonongchanpin','修改')" 
										type="primary" 
										size="mini" 
										icon="el-icon-edit"
										@click="addOrUpdateHandler(scope.row.id)"
										class="action-btn edit-btn"
									>
										编辑
									</el-button>

									<el-button 
										v-if="isAuth('rexiaonongchanpin','删除')" 
										type="danger" 
										size="mini" 
										icon="el-icon-delete"
										@click="deleteHandler(scope.row.id)"
										class="action-btn delete-btn"
									>
										删除
									</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</div>

			<!-- 分页 -->
			<div class="pagination-section">
				<el-pagination
					@size-change="sizeChangeHandle"
					@current-change="currentChangeHandle"
					:current-page="pageIndex"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalPage"
					class="data-pagination"
				></el-pagination>
			</div>
		</template>
		
		<!-- 添加/修改页面 -->
		<add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
	</div>
</template>

<script>
import axios from 'axios'
import AddOrUpdate from "./add-or-update";
export default {
  data() {
    return {
      searchForm: {
        key: ""
      },
      form:{},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      sfshVisiable: false,
      shForm: {},
      chartVisiable: false,
      chartVisiable1: false,
      chartVisiable2: false,
      chartVisiable3: false,
      chartVisiable4: false,
      chartVisiable5: false,
      addOrUpdateFlag:false,
      layouts: ["total","prev","pager","next","sizes","jumper"],

    };
  },
  created() {
    this.init();
    this.getDataList();
    this.contentStyleChange()
  },
  mounted() {
  },
  filters: {
    htmlfilter: function (val) {
      return val.replace(/<[^>]*>/g).replace(/undefined/g,'');
    }
  },
  components: {
    AddOrUpdate,
  },
  methods: {

    contentStyleChange() {
      this.contentPageStyleChange()
    },
    // 分页
    contentPageStyleChange(){
      let arr = []

      // if(this.contents.pageTotal) arr.push('total')
      // if(this.contents.pageSizes) arr.push('sizes')
      // if(this.contents.pagePrevNext){
      //   arr.push('prev')
      //   if(this.contents.pagePager) arr.push('pager')
      //   arr.push('next')
      // }
      // if(this.contents.pageJumper) arr.push('jumper')
      // this.layouts = arr.join()
      // this.contents.pageEachNum = 10
    },








    // 获取表格索引
    getTableIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        nongchanpinmingcheng: '',
        pinpai: ''
      };
      this.search();
    },

    // 处理图片加载错误
    handleImageError(event) {
      event.target.style.display = 'none';
      event.target.nextElementSibling.style.display = 'flex';
    },

    // 获取库存标签类型
    getStockTagType(stock) {
      if (stock == -1) return 'info';
      if (stock <= 10) return 'danger';
      if (stock <= 50) return 'warning';
      return 'success';
    },

    init () {
    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: 'id',
        order: 'desc',
      }
           if(this.searchForm.nongchanpinmingcheng!='' && this.searchForm.nongchanpinmingcheng!=undefined){
            params['nongchanpinmingcheng'] = '%' + this.searchForm.nongchanpinmingcheng + '%'
          }
           if(this.searchForm.pinpai!='' && this.searchForm.pinpai!=undefined){
            params['pinpai'] = '%' + this.searchForm.pinpai + '%'
          }
      this.$http({
        url: "rexiaonongchanpin/page",
        method: "get",
        params: params
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list;
          this.totalPage = data.data.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id,type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.crossAddOrUpdateFlag = false;
      if(type!='info'){
        type = 'else';
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id,type);
      });
    },

    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 删除
    deleteHandler(id) {
      var ids = id
        ? [Number(id)]
        : this.dataListSelections.map(item => {
            return Number(item.id);
          });
      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "rexiaonongchanpin/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },


  }

};
</script>
<style lang="scss" scoped>
.medicine-list-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: white;
		padding: 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-icon {
			width: 56px;
			height: 56px;
			background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
			border-radius: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);

			.icon {
				width: 24px;
				height: 24px;
				fill: white;
			}
		}

		.header-text {
			flex: 1;
			margin-left: 16px;

			.page-title {
				font-size: 24px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 4px 0;
			}

			.page-description {
				color: #64748b;
				font-size: 14px;
				margin: 0;
			}
		}

		.header-actions {
			.add-btn {
				padding: 12px 24px;
				font-weight: 500;
				border-radius: 8px;
			}
		}
	}
}

// 筛选区域
.filter-section {
	margin-bottom: 24px;

	.filter-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 24px;
		}
	}

	.filter-content {
		.search-form {
			margin: 0;

			.filter-row {
				display: flex;
				align-items: flex-end;
				gap: 20px;
				flex-wrap: wrap;
			}

			.filter-group {
				display: flex;
				flex-direction: column;
				min-width: 200px;

				.filter-label {
					font-size: 14px;
					font-weight: 500;
					color: #374151;
					margin-bottom: 8px;
				}

				.filter-input {
					.search-input, .search-select {
						width: 200px;
					}
				}
			}

			.filter-actions {
				display: flex;
				gap: 12px;
				margin-left: auto;

				.el-button {
					padding: 10px 20px;
					font-weight: 500;
					border-radius: 6px;
				}

				.search-btn {
					background: #3b82f6;
					border-color: #3b82f6;
				}

				.reset-btn {
					color: #6b7280;
					border-color: #d1d5db;

					&:hover {
						color: #374151;
						border-color: #9ca3af;
					}
				}
			}
		}
	}
}

// 工具栏
.toolbar-section {
	margin-bottom: 16px;

	.toolbar-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 16px 24px;
		}
	}

	.toolbar-content {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.selection-info {
			display: flex;
			align-items: center;
			gap: 8px;
			color: #3b82f6;
			font-size: 14px;

			i {
				font-size: 16px;
			}

			strong {
				color: #1d4ed8;
			}
		}

		.batch-actions {
			.batch-delete-btn {
				padding: 8px 16px;
				font-size: 13px;
			}
		}
	}
}

// 表格区域
.table-section {
	margin-bottom: 24px;

	.table-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 0;
		}
	}

	.data-table {
		:deep(.el-table__header) {
			th {
				background: #f8fafc;
				color: #374151;
				font-weight: 600;
				border-bottom: 1px solid #e5e7eb;
				padding: 16px 0;

				.cell {
					padding: 0 16px;
				}
			}
		}

		:deep(.el-table__body) {
			tr {
				&:hover {
					background: #f8fafc;
				}

				td {
					border-bottom: 1px solid #f1f5f9;
					padding: 16px 0;

					.cell {
						padding: 0 16px;
					}
				}
			}
		}



		// 药品名称
		.medicine-name {
			display: flex;
			align-items: center;
			gap: 12px;
			color: #374151;

			.medicine-icon {
				width: 20px;
				height: 20px;
				display: flex;
				align-items: center;
				justify-content: center;

				svg {
					width: 16px;
					height: 16px;
					fill: #3b82f6;
				}
			}

			.medicine-text {
				font-weight: 500;
				font-size: 14px;
			}
		}

		// 药品图片
		.medicine-image {
			display: flex;
			justify-content: center;
			align-items: center;

			.image-wrapper {
				.medicine-img {
					width: 60px;
					height: 60px;
					object-fit: cover;
					border-radius: 6px;
					border: 1px solid #e5e7eb;
				}
			}

			.image-placeholder {
				width: 60px;
				height: 60px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				background: #f3f4f6;
				border: 1px dashed #d1d5db;
				border-radius: 6px;
				color: #9ca3af;
				font-size: 12px;

				i {
					font-size: 20px;
					margin-bottom: 4px;
				}
			}
		}

		// 标签样式
		.category-tag, .organic-tag, .stock-tag {
			font-weight: 500;
			
			i {
				margin-right: 4px;
			}
		}

		// 品牌信息
		.brand-info {
			.brand-text {
				color: #374151;
				font-weight: 500;
			}
		}

		// 限制文本
		.limit-text {
			color: #6b7280;
			font-size: 13px;
		}

		// 库存信息
		.stock-info {
			display: flex;
			justify-content: center;
		}

		// 点击信息
		.click-info {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 4px;
			color: #6b7280;
			font-size: 13px;

			i {
				font-size: 14px;
			}
		}

		// 价格信息
		.price-info {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 2px;
			font-weight: 600;
			color: #dc2626;

			.price-symbol {
				font-size: 12px;
			}

			.price-value {
				font-size: 14px;
			}
		}

		// 操作按钮
		.action-buttons {
			display: flex;
			gap: 6px;
			justify-content: center;
			flex-wrap: wrap;

			.action-btn {
				padding: 6px 12px;
				font-size: 12px;
				border-radius: 4px;
				min-width: auto;

				&.view-btn {
					background: #6b7280;
					border-color: #6b7280;
					color: white;

					&:hover {
						background: #4b5563;
						border-color: #4b5563;
					}
				}

				&.edit-btn {
					background: #3b82f6;
					border-color: #3b82f6;

					&:hover {
						background: #2563eb;
						border-color: #2563eb;
					}
				}



				&.delete-btn {
					background: #ef4444;
					border-color: #ef4444;

					&:hover {
						background: #dc2626;
						border-color: #dc2626;
					}
				}
			}
		}
	}
}

// 分页区域
.pagination-section {
	display: flex;
	justify-content: center;

	.data-pagination {
		background: white;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
}

// 响应式设计
@media (max-width: 1200px) {
	.medicine-list-container {
		padding: 20px;
	}

	.filter-section {
		.filter-content {
			.search-form {
				.filter-row {
					flex-direction: column;
					align-items: stretch;
					gap: 16px;
				}

				.filter-group {
					min-width: auto;

					.filter-input {
						.search-input, .search-select {
							width: 100%;
						}
					}
				}

				.filter-actions {
					margin-left: 0;
					justify-content: center;

					.el-button {
						flex: 1;
						max-width: 120px;
					}
				}
			}
		}
	}

	.table-section {
		overflow-x: auto;

		.data-table {
			min-width: 1000px;

			.action-buttons {
				flex-direction: column;
				gap: 4px;

				.action-btn {
					width: 100%;
					max-width: 60px;
					padding: 4px 8px;
					font-size: 11px;
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.medicine-list-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			gap: 16px;
			text-align: center;

			.header-text {
				margin-left: 0;

				.page-title {
					font-size: 20px;
				}
			}
		}
	}

	.toolbar-section {
		.toolbar-content {
			flex-direction: column;
			gap: 12px;
			text-align: center;
		}
	}

	.table-section {
		.data-table {
			min-width: 800px;
		}
	}
}

@media (max-width: 480px) {
	.medicine-list-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			padding: 16px;

			.header-icon {
				width: 48px;
				height: 48px;

				.icon {
					width: 20px;
					height: 20px;
				}
			}

			.header-text {
				.page-title {
					font-size: 18px;
				}

				.page-description {
					font-size: 13px;
				}
			}

			.header-actions {
				.add-btn {
					padding: 10px 16px;
					font-size: 13px;
				}
			}
		}
	}

	.filter-section {
		.filter-card {
			:deep(.el-card__body) {
				padding: 16px;
			}
		}
	}

	.pagination-section {
		.data-pagination {
			padding: 16px;
			
			:deep(.el-pagination) {
				.el-pagination__total,
				.el-pagination__jump {
					display: none;
				}
			}
		}
	}
}
</style>
